var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_153_1623",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 67.5C39.2687 67.5053 43.4965 66.667 47.4402 65.0334C51.384 63.3998 54.9661 61.003 57.9808 57.9808C61.003 54.9661 63.3998 51.384 65.0334 47.4402C66.667 43.4965 67.5053 39.2687 67.5 35C67.5053 30.7313 66.667 26.5036 65.0334 22.5598C63.3998 18.616 61.003 15.0339 57.9808 12.0193C54.9661 8.99704 51.384 6.60026 47.4402 4.96664C43.4965 3.33302 39.2687 2.49476 35 2.50002C30.7313 2.49476 26.5036 3.33302 22.5598 4.96664C18.616 6.60026 15.0339 8.99704 12.0193 12.0193C8.99704 15.0339 6.60026 18.616 4.96664 22.5598C3.33302 26.5036 2.49476 30.7313 2.50002 35C2.49476 39.2687 3.33302 43.4965 4.96664 47.4402C6.60026 51.384 8.99704 54.9661 12.0193 57.9808C15.0339 61.003 18.616 63.3998 22.5598 65.0334C26.5036 66.667 30.7313 67.5053 35 67.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35L31.75 44.75L51.25 25.25",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_153_1623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4 -4H74V74H-4V-4Z",
    fill: "#FEC200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSuccess);
export default __webpack_public_path__ + "static/media/upload-success.6462a386c5fde8532b5ea83a74536a87.svg";
export { ForwardRef as ReactComponent };